import React from 'react';
import { Link, Route } from 'react-router-dom'
import Be from '../../icons/components/be.js'
import './description.css';
import FlechaAbajo from '../../icons/components/flechaAbajo.js'

class descriptionProject extends React.Component {

  constructor(props){
    super(props)
    this.state={
      bajo:4,
    }
  }

  adicionarUno(){
    try{
      this.setState({bajo:1});
      console.log(this.state.bajo);
    }catch(error){
      console.log(error)
    }
  }
  adicionarDos(){
    try{
      this.setState({bajo:2});
      console.log(this.state.bajo);
    }catch(error){
      console.log(error)
    }
  }
  adicionarTres(){
    try{
      this.setState({bajo:3});
      console.log(this.state.bajo);
    }catch(error){
      console.log(error)
    }
  }
  adicionarFinal(){
    try{
      this.setState({bajo:4});
      console.log(this.state.bajo);
    }catch(error){
      console.log(error)
    }
  }

  aparece(){
    if (this.state.bajo == 1) {
      return  <p>This project is carried out from an initiative of students of Interactive Media Design, with the need to show the world one of the ways in which we can take users to a different and innovative experience through particular elements. We are faithful believers in the potential of the digital world today, and how much it applies to the industry in general.</p>
    } else if (this.state.bajo == 2) {
      return  <p>Augmented reality is about combining the real world with the virtual world through a computer-based process, enriching the visual experience and improving the quality of communication.</p>
    } else if (this.state.bajo == 3) {
      return  <p>Thanks to this technology you can add visual information to reality, and create all kinds of interactive experiences: 3D product catalogs, virtual clothes testers, video games and much more.</p>
    } else if (this.state.bajo == 4) {
      return  <p>Monuks is an interactive experience between a notebook and a cell phone. This system is given through a mobile application and augmented reality technology, which takes the user to interact with a game that is displayed on the back cover of the Monuks notebook through the camera of the cell phone.</p>
    }
  }

  render() {
    return (
      <div className='descripcionProjecto'>


        <section className="flechaUp">
          <Link to='/projects' >
        <figure className="flechaArriba">
        <FlechaAbajo size={23} color="white" />
        </figure>
        </Link>
        </section>
        <section className="flecha">
          <Link to='/projects'>
        <figure className="flechaAbajo">
        <FlechaAbajo size={23} color="white" />
        </figure>
        </Link>
        </section>
        <section className="flecha">
          <Link to='/projectsEmpfehlung' >
        <figure className="flechaAbajo">
        <FlechaAbajo size={23} color="white" />
        </figure>
        </Link>
        </section>

        <div className='tituloProjecto '>
          <h2 className='estiloFuente'>Monucks</h2>
          <div className='estiloFuente'>
            <h3>Business project</h3>
            <h3 className='fecha'>2017</h3>
          </div>
        </div>
        <div className='pasosProceso '>
          <div className='estiloFuente'><h2>Process Step</h2></div>

          <div className='estiloFuente'>
            <div className='numberStep'  onClick={this.adicionarUno.bind(this)} >  1 </div>
            <div className='numberStep' onClick={this.adicionarDos.bind(this)}>  2   </div>
            <div className='numberStep' onClick={this.adicionarTres.bind(this)}>  3   </div>
            <div className='numberStep' onClick={this.adicionarFinal.bind(this)}>  Final </div>
          </div>

          <div className='hijoTresTres'>

            {this.aparece()}
          </div>
        </div>
        <div className='hijoTresCuatro '>
          <div className='estiloFuente'><h3>Repositorio o url del proyecto:</h3></div>
          <div className='estiloFuente'>
            <a  href="https://www.behance.net/gallery/56160327/Monuks" >
            <figure className="be">
              <Be size={30} color="white" />
            </figure>
          </a>
          </div>
        </div>
      </div>
    )}
  }

  export default descriptionProject;



// WEBPACK FOOTER //
// ./src/projects/Monucks/description.js